import * as React from "react";
export function useEventHandlers(target, onEvents) {
    React.useEffect(function onEventHandlers() {
        if (!target || !onEvents)
            return;
        onEvents.forEach(([eventType, listener]) => {
            target.addEventListener(eventType, listener, false);
        });
        return function destroy() {
            onEvents.forEach(([eventType, listener]) => {
                target.removeEventListener(eventType, listener, false);
            });
        };
    }, [onEvents, target]);
}
